import requests from "./httpService";

const DistrictServices = {

    getState: async () =>{
        return requests.get(`/newlocation/states-all`);
    },

    updateStateStatus : async (id,body) =>{
        console.warn(body);
        return requests.patch(`newlocation/updateStateStatus/${id}`,body);
    },
    
    getCities: async (stateId) => {
        return requests.get(`/newlocation/cities-all/${stateId}`);
    },

    updateCityStatus : async (id,body) =>{
        console.warn(body);
        return requests.patch(`newlocation/updateCityStatus/${id}`,body);
    },

    getPincodes: async (cityId) => {
        return requests.get(`/newlocation/pincodes-all/${cityId}`);
    },

    updatePincodeStatus : async (id,body) =>{
        console.warn(body);
        return requests.patch(`newlocation/updatePincodeStatus/${id}`,body);
    },

    addCity: async(body)=>{
        return requests.post(`newlocation/city/add`,body);
    },

     addPincode: async(body)=>{
        return requests.post(`newlocation/pincode/add`,body);
    }
    



}
export default DistrictServices;